/* Vawagra — front-end behaviors: reviews carousel + reels play/pause. Vanilla, RTL-aware. */
(function () {
  'use strict';

  function initReviewsCarousel(root) {
    var track = root.querySelector('[data-vw-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    var prev = root.querySelector('[data-vw-prev]');
    var next = root.querySelector('[data-vw-next]');
    var rtl = getComputedStyle(root).direction === 'rtl';
    var interval = parseInt(root.getAttribute('data-vw-interval'), 10) || 3000;
    var index = 0;
    var timer = null;

    function perView() {
      var w = window.innerWidth;
      if (w >= 990) return 4;
      if (w >= 750) return 3;
      if (w >= 520) return 2;
      return 1;
    }
    function step() {
      var s = getComputedStyle(track);
      var gap = parseFloat(s.columnGap || s.gap || '0') || 0;
      return items[0].getBoundingClientRect().width + gap;
    }
    function maxIndex() { return Math.max(0, items.length - perView()); }
    function apply() {
      var x = index * step();
      track.style.transform = 'translateX(' + (rtl ? x : -x) + 'px)';
    }
    function go(dir) {
      index += dir;
      if (index > maxIndex()) index = 0;
      if (index < 0) index = maxIndex();
      apply();
    }
    function start() { stop(); timer = setInterval(function () { go(1); }, interval); }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    if (next) next.addEventListener('click', function () { go(1); start(); });
    if (prev) prev.addEventListener('click', function () { go(-1); start(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    window.addEventListener('resize', function () {
      if (index > maxIndex()) index = maxIndex();
      apply();
    });
    apply();
    start();
  }

  // Header state: transparent overlay at the top of the hero, frosted float once scrolled.
  //
  // This does NOT use Dawn's .scrolled-past-header. With sticky_header_type "always",
  // header.liquid's onScroll gates on `scrollTop > this.headerBounds.bottom`, and
  // headerBounds is left as `{}` here — its IntersectionObserver never resolves, so
  // `> undefined` is always false and the class is never added. Verified live: at
  // scrollY 1200 the header still had no state class and had scrolled off-screen.
  function initHeaderState() {
    var header = document.querySelector('.section-header');
    if (!header) return;
    // Mark the hero case with a plain class instead of styling via body:has(.vw-hero-section).
    // Chrome does not reliably re-evaluate a :has()-prefixed rule when a class flips on an
    // element inside the :has() subject's subtree: with the solid class on, el.matches() for
    // the transparent rule returned false while getComputedStyle still reported its white —
    // and no other matching rule could produce white (--color-link is 64,20,47). Plain
    // classes invalidate correctly, and if this JS never runs the header just stays in
    // Dawn's readable default rather than going transparent over a white page.
    if (document.querySelector('.vw-hero-section')) header.classList.add('vw-header-over-hero');
    var threshold = 80; // ~header height: past this the hero is no longer behind the bar
    // Deliberately not rAF-throttled: the handler only reads window.scrollY and flips one
    // class — no layout is written — and an rAF wrapper silently stops updating wherever
    // rAF is frozen (hidden tab, bfcache restore), leaving the bar stuck in the wrong state.
    function update() {
      header.classList.toggle('vw-header-solid', window.scrollY > threshold);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('pageshow', update);
    update();
  }

  // Arabic titles for Shopify's policy pages.
  //
  // Shopify renders /policies/* itself and hard-codes the English heading. There is no
  // server-side hook: ShopPolicyInput takes only {type, body}, translatableContent for a
  // ShopPolicy exposes only `body`, and templates/policy.liquid is ignored (verified —
  // the page still came back with Shopify's own container). The shop's sole locale is ar,
  // so "Refund policy" over Arabic body copy is a platform artifact, not a setting.
  // Rewriting the heading here is the only lever left; without JS the English title stays,
  // which is the same as today rather than a regression.
  var POLICY_TITLES = {
    'privacy-policy': 'سياسة الخصوصية',
    'refund-policy': 'سياسة الاستبدال والاسترجاع',
    'shipping-policy': 'سياسة الشحن والتوصيل',
    'terms-of-service': 'الشروط والأحكام',
    'contact-information': 'معلومات التواصل',
    'legal-notice': 'إشعار قانوني',
    'terms-of-sale': 'شروط البيع',
    'subscription-policy': 'سياسة الاشتراكات'
  };
  function initPolicyTitle() {
    var m = location.pathname.match(/\/policies\/([a-z-]+)/);
    if (!m) return;
    var title = POLICY_TITLES[m[1]];
    if (!title) return;
    var h1 = document.querySelector('.shopify-policy__title h1');
    if (h1) h1.textContent = title;
    if (document.title.indexOf(title) === -1) {
      document.title = title + ' – ' + (window.Shopify && Shopify.shop ? document.title.split('–').pop().trim() : document.title);
    }
  }

  // Cart "make it 3 jars" one-click. Sets the honey line to qty 3 (which trips the live
  // −30 ﷼ bundle discount) then re-renders the drawer / cart page in place.
  function initCartBundle() {
    if (window.__vwCartBundleBound) return;
    window.__vwCartBundleBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vw-bundle-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-vw-bundle-id');
      var qty = parseInt(btn.getAttribute('data-vw-bundle-qty'), 10) || 3;
      if (!id) return;
      btn.disabled = true;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: id, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch(root + '?sections=cart-drawer,cart-icon-bubble,main-cart-items,main-cart-footer');
      }).then(function (r) { return r.json(); }).then(function (sec) {
        function swapInner(sel, key) {
          if (!sec[key]) return;
          var doc = new DOMParser().parseFromString(sec[key], 'text/html');
          var fresh = doc.querySelector(sel), cur = document.querySelector(sel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        }
        swapInner('#CartDrawer', 'cart-drawer');
        swapInner('#main-cart-items', 'main-cart-items');
        swapInner('#main-cart-footer', 'main-cart-footer');
        if (sec['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(sec['cart-icon-bubble'], 'text/html');
          var f = d.querySelector('.shopify-section') || d.body.firstElementChild;
          document.querySelectorAll('#cart-icon-bubble').forEach(function (el) { if (f) el.innerHTML = f.innerHTML; });
        }
      }).catch(function () {}).then(function () { btn.disabled = false; });
    });
  }

  // Cart promo code. Shopify only applies discount codes at checkout, so we route the
  // shopper through /discount/{code}?redirect=/checkout — the code sticks to the session
  // and the discount is visible on checkout. Delegated so it survives cart re-renders.
  function initPromoCode() {
    if (window.__vwPromoBound) return;
    window.__vwPromoBound = true;
    function apply(scope) {
      var input = scope.querySelector('[data-vw-promo-input]');
      if (!input) return;
      var code = (input.value || '').trim();
      if (!code) { input.focus(); return; }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=/checkout';
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-vw-promo-apply]');
      if (!btn) return;
      e.preventDefault();
      var scope = btn.closest('[data-vw-promo]') || document;
      apply(scope);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest && e.target.closest('[data-vw-promo-input]');
      if (!input) return;
      e.preventDefault();
      var scope = input.closest('[data-vw-promo]') || document;
      apply(scope);
    });
  }

  function boot() {
    document.querySelectorAll('[data-vw-reviews]').forEach(initReviewsCarousel);
    initHeaderState();
    initPolicyTitle();
    initCartBundle();
    initPromoCode();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
